// test2888
(2888 && 0);
